'use client';

import { useState } from 'react';

import { MAX_ITEMS_PER_LIST } from '@shared/utils';

export const usePagination = ({
  initialPage = 1,
  pageCount = MAX_ITEMS_PER_LIST,
}: {
  initialPage?: number;
  pageCount?: number;
}) => {
  const [currentPage, setCurrentPage] = useState(initialPage);

  const startIndex = (currentPage - 1) * pageCount;
  const endIndex = startIndex + pageCount;

  return { currentPage, endIndex, setCurrentPage, startIndex };
};
